import { QueryResult } from '../../../../GlobalComponents/QueryResult';
import { Row } from '../../../../Order/components/Details/Row';
import { useAppSelector } from '../../../../reduxstore/hooks';
import { useGetOrderHistoryQuery } from '../../../api';
import { useGetStoreQuery } from '../../../graphql';
import { OrderDetailItem } from './OrderDetailItems';
import {
	DetailContainer,
	DetailDivider,
	DetailInlineFlex,
	DetailLeft,
	DetailRight,
	DetailTitle,
	DetailTitleContainer,
	SubTotalAmount,
	SubTotalHeader,
	TotalAmount,
	TotalOrangeText
} from './OrderDetailStyled';

const OrderDetailView: React.FC = () => {
	const order = window.location.href.split('/').pop();

	const userId = useAppSelector(state => state.authReducer.id);
	const { data, error, isLoading } = useGetOrderHistoryQuery(userId);
	const thisOrder = data.data.order_history.find(
		(o: any) => o.order_id === order
	);
	const snumber = parseInt(thisOrder.store_id);

	const handlePrice = (price: number) => {
		const result = (price / 100).toFixed(2);
		return result;
	};

	const HandleStoreAddress = () => {
		const query = useGetStoreQuery({
			variables: { storeId: snumber }
		});
		return (
			query.data?.store.address1 +
			', ' +
			query.data?.store.city +
			', ' +
			query.data?.store.state +
			' ' +
			query.data?.store.zipCode
		);
	};

	const HandleStorePhone = () => {
		const query = useGetStoreQuery({
			fetchPolicy: 'network-only',
			variables: { storeId: snumber }
		});

		return query?.data?.store?.phone;
	};

	return (
		<QueryResult data={data} error={error} loading={isLoading}>
			<DetailContainer>
				<DetailTitleContainer>
					<DetailTitle>Thanks for your order!</DetailTitle>
				</DetailTitleContainer>
				<DetailDivider></DetailDivider>
				<div>
					<Row
						pt={0}
						left="Name:"
						right={
							data.data.app_user.profile.first_name +
							' ' +
							data.data.app_user.profile.last_name
						}
					/>
					<Row pb={0} left="Order ID:" right={thisOrder.order_id} />
					<Row
						pb={0}
						left="Location:"
						right={
							<a
								href={
									'https://www.google.com/maps/search/?api=1&query=' +
									HandleStoreAddress()
								}
								target="_blank"
								rel="noreferrer"
							>
								{HandleStoreAddress()}
							</a>
						}
					/>
					<Row
						pb={0}
						left="Location Phone:"
						right={
							<a href={'tel:1+' + HandleStorePhone()}>
								{HandleStorePhone()}
							</a>
						}
					/>
				</div>
				<DetailDivider></DetailDivider>
				<DetailInlineFlex>
					<DetailLeft>Item</DetailLeft>
					<DetailRight>Price</DetailRight>
				</DetailInlineFlex>
				<DetailDivider></DetailDivider>
				{thisOrder?.orderitems.map((item: any) => (
					<OrderDetailItem
						id={item.item.item_id}
						size={item.size}
						product={{
							id: item.item.product.product_id,
							name: item.item.product.name
						}}
						price={handlePrice(item.price)}
						quantity={item.quantity}
						tax_amount={item.tax_amount}
						modifiers={item.modifiers}
					></OrderDetailItem>
				))}
				<DetailInlineFlex>
					<SubTotalHeader>Subtotal</SubTotalHeader>
					<SubTotalAmount>
						${handlePrice(thisOrder.sub_total)}
					</SubTotalAmount>
				</DetailInlineFlex>
				<DetailInlineFlex>
					<SubTotalHeader>Tax</SubTotalHeader>
					<SubTotalAmount>
						${handlePrice(thisOrder.tax_amount)}
					</SubTotalAmount>
				</DetailInlineFlex>
				<DetailInlineFlex>
					<TotalOrangeText>Total</TotalOrangeText>
					<TotalAmount>${handlePrice(thisOrder.total)}</TotalAmount>
				</DetailInlineFlex>
				<DetailDivider></DetailDivider>
			</DetailContainer>
		</QueryResult>
	);
};

export default OrderDetailView;
